import { useLocation, Link as RouterLink, useParams,  } from "react-router-dom";
import Container from "@mui/material/Container"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
import Stack from "@mui/material/Stack"
import { useAccount, useObjects } from "../state/AppDataStateProvider";
import { formatCurrency } from "@sb1finans/components/dist/FormattedCurrency"
import { formatDate } from "../utils/formatters";
import DirectionsCar from "@mui/icons-material/DirectionsCar"
import { CustomThemeContext } from "@sb1finans/components/dist/themes/CustomThemeContext";
import { useContext } from "react";

const formatPecent = (value?: string) => {
    return value ? `${parseFloat(value).toFixed(2)} %` : ""
}

export const AccountDetailsPage: React.FC = () => {

    console.log("AccountDetailsPage")

    const account = useAccount()
    const objects = useObjects()
    const location = useLocation()

    const {currentTheme } = useContext(CustomThemeContext)

    const data = [
        { key: 'Lån i dag', value: formatCurrency(parseFloat(account?.bookedBalance ?? "0")) },
        { key: 'Nominell rente', value: formatPecent(account?.interestRate) },
        { key: 'Effektiv rente', value: formatPecent(account?.effectiveRate) },
        { key: 'Neste innbetaling', value: formatCurrency(parseFloat(account?.pendingPayoutAmount ?? "0")) },
        { key: 'Forfallsdato', value: formatDate(new Date(account?.principalDate)) },
    ];

    const accountObjects = account?.id && objects.get(account.id)
    console.log("AccountObjects: ", accountObjects)
    console.log("Theme: ", currentTheme.palette)
    return (
      <Container maxWidth="sm">
        <Stack sx={{marginBottom: "24px"}} alignItems="center" spacing={2}>
            <DirectionsCar sx={{width: "80px", height: "80px", fill: currentTheme.palette.primary.main}} />
            { accountObjects && (
        <>
            <Typography variant="h5">{`${accountObjects[0].description} - ${accountObjects[0].registrationNumber}`}</Typography>
        </>
        )}
        </Stack>
        
        {data.map((item, index) => (
          <Box key={index} display="flex" justifyContent="space-between" marginBottom={2}>
            <Typography variant="body1">{item.key}</Typography>
            <Typography variant="body1" fontWeight="bold">{item.value}</Typography>
          </Box>
        ))}
        <Stack spacing={2}>
            <Link component={RouterLink} to={`${location.pathname}/betalingsplan`}>Se betalingsplan</Link>
            <Link component={RouterLink} to={`${location.pathname}/transaksjoner`}>Se transaksjoner</Link>
            <Link component={RouterLink} to={`${location.pathname}/fakturaer`}>Se fakturaer</Link>
            <Link component={RouterLink} to={`${location.pathname}/forfallsdato`}>Endre forfallsdato</Link>
            <Link component={RouterLink} to={`${location.pathname}/innbetaling`}>Ekstra innbetaling</Link>
            <Link component={RouterLink} to={`${location.pathname}/innfri`}>Innfri lån</Link>
        </Stack>
      </Container>
    );
}